// API service functions for components and stores
import api from './client';

export interface Component {
  id: number;
  name: string;
  description?: string;
  component_type?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface ComponentCreate {
  component_id: string;
  component_name: string;
  page_id: string;
  description?: string;
  component_type?: string;
}

export interface ComponentUpdate {
  component_id?: string;
  component_name?: string;
  page_id?: string;
  description?: string;
  component_type?: string;
  is_active?: boolean;
}

export interface Store {
  id: number;
  name: string;
  description?: string;
  store_type?: string;
  connection_config?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface StoreCreate {
  name: string;
  description?: string;
  store_type?: string;
  connection_config?: string;
}

export interface StoreUpdate {
  name?: string;
  description?: string;
  store_type?: string;
  connection_config?: string;
  is_active?: boolean;
}

export const componentApi = {
  create: async (data: ComponentCreate): Promise<Component> => {
    const response = await api.post('/v1/components/', data);
    return response.data;
  },

  list: async (skip = 0, limit = 100): Promise<Component[]> => {
    const response = await api.get(`/v1/components/?skip=${skip}&limit=${limit}`);
    return response.data;
  },

  get: async (component_id: string): Promise<Component> => {
    const response = await api.get(`/v1/components/${component_id}`);
    return response.data;
  },

  update: async (component_id: string, data: ComponentUpdate): Promise<Component> => {
    const response = await api.put(`/v1/components/${component_id}`, data);
    return response.data;
  },

  disable: async (component_id: string): Promise<{ message: string }> => {
    const response = await api.delete(`/v1/components/${component_id}`);
    return response.data;
  }
};

export const storeApi = {
  create: async (data: StoreCreate): Promise<Store> => {
    const response = await api.post('/v1/stores/', data);
    return response.data;
  },

  list: async (skip = 0, limit = 100): Promise<Store[]> => {
    const response = await api.get(`/v1/stores/?skip=${skip}&limit=${limit}`);
    return response.data;
  },

  get: async (id: number): Promise<Store> => {
    const response = await api.get(`/v1/stores/${id}`);
    return response.data;
  },

  update: async (id: number, data: StoreUpdate): Promise<Store> => {
    const response = await api.put(`/v1/stores/${id}`, data);
    return response.data;
  },

  disable: async (id: number): Promise<{ message: string }> => {
    const response = await api.delete(`/v1/stores/${id}`);
    return response.data;
  }
};
